import { render, staticRenderFns } from "./new_trusteeship.vue?vue&type=template&id=fecad562&scoped=true&"
import script from "./new_trusteeship.vue?vue&type=script&lang=js&"
export * from "./new_trusteeship.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeship.vue?vue&type=style&index=0&id=fecad562&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecad562",
  null
  
)

export default component.exports